$(document).ready(function() {

    $(document).on("change", "#university-search-term", function() {
        searchUniversities();
    });
    
    $(document).on("change", ".search-home-header", function() {
        searchReduced($(this));
    });

    function searchReduced(element){
        var term = element.val();

        var getUrl = window.location;
        var baseUrl = "https://" + getUrl.host + "/";
        console.log(baseUrl);

        var stringParts = ['','',''];

        var explore = 'explore/';

        if(term){
            stringParts[3] = '?search='+term;
        }

        var searchUrl = baseUrl + explore + stringParts[3];

        window.location.replace(searchUrl);
    }

    $(document).on("change", "#university-search-term", function () {
        searchUniversities($(this).val());
    });

    function searchUniversities(term) {

        var stringPart = '';
        if (term) {
            stringPart = '?term=' + term;
        }

        let searchUrl = app_url + '/university/' + slug + stringPart;

        location.replace(searchUrl);
    }
});
